import React, { useEffect } from "react";
import modalDrag from "../hooks/modalDrag";

import '../design/styles/alert.css';

import errorIcon from '../design/icons/no-entry.svg';
import successIcon from '../design/icons/ok2.svg';
import warningIcon from '../design/icons/warning.svg';

// uso: enviar un json con los siquientes campos
//   msg: Mensaje a mostrar,
//   title: titulo de la alerta, 
//   color: color de las letras del mensaje, 
//   vanish: tiempo en milisegundos para que desaparezca la alerta (true = 2000),
//   type: danger, warning, success, info, error  - Para que agregue un icono de acuerdo al tipo
//     
//   overlay: true para que ponga un overlay,
//  closeButton: en true para que aparezca un boton de cerrar
//  buttons: un array de objetos. Cada objeto debe tenes una etiqueta label, la que mostrara
//    la etiqueta del boton, y una etiqueta onClick, con una funcion, que es la que se ejecuta
//    al apretar el boton. Ej: 
//      buttons: [
//        {label: 'Aceptar', onClick: () => alert('Aceptar')},
//        {label: 'Cancelar', onClick: () => alert('Cancelar'),          
//      }]

const Alert = ({ options, closeAlert }) => {
 
  useEffect(() => {

    modalDrag(document.getElementById("alert"));
    
    if (options.color) {
      document.getElementById("alert-body").style.color = options.color
    }
  }, [options.color]);

  if (options.vanish) {
    setTimeout(closeAlert, options.vanish === true ? 2000 : (+options.vanish || 2000));
  }

  const handleClick = (event) => {
    options.buttons[parseInt(event.target.id)].onClick()
    closeAlert()
  }

  return (
    <div>
      <div className="alert" id="alert">
        <div className="alert-header">
          <h3>{options.title || "Alerta"}</h3>
          <button type="button" onClick={closeAlert} className="alert-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
          </button>
        </div>
        <div className="alert-body" id="alert-body">
          {options.type === 'success' &&
            <img src={successIcon} height = "30px" width= "30px"  />
          }
          {options.type === 'error' &&
            <img src={errorIcon} height = "30px" width= "30px"/>
          }
          {options.type === 'warning' &&
            <img src={warningIcon} height = "30px" width= "30px"/>
          }
          <p>{options.msg}</p>
        </div>
        {(options.buttons || options.closeButton) &&
          <div className="alert-buttons">
            {options.buttons && 
              options.buttons.map ((item, index) => 
                <button
                  key = {`alert-button-${index}`}
                  onClick = {handleClick}
                  className= "alert-button"
                  id = {index}
                >{item.label}</button>        
              )}
            {options.closeButton &&
              <button
              onClick = {closeAlert}
              className= "alert-button"
            >Cerrar</button>
            }
          </div>
        }
      </div>
      {options.overlay && <div className="overlay"></div>}
    </div>
  );
};

export default Alert;
